module.exports = __webpack_public_path__ + "img/IMG_0338.08d57321.png";